export class animateOnScrollModule {



	constructor() {
		this.animateElements()
	}
	private animateElements = () => {
		this.animateEffect
		window.addEventListener("resize", this.animateEffect);
		document.addEventListener("scroll", this.animateEffect);
	}


	private animateEffect = () => {
		const aniamteItemList: NodeList = document.querySelectorAll("[data-animate]");
		const animateArray: HTMLElement[] = Array.prototype.slice.call(aniamteItemList);

		let windowHeight: number = window.innerHeight;
		let windowScrollPosition: number = window.pageYOffset || document.documentElement.scrollTop;
		let windowBottomPosition: number = (windowScrollPosition + windowHeight);

		animateArray.forEach((element: HTMLElement) => {
			let elementHeight: number = element.offsetHeight;
			let elementTopPosition: number = element.offsetTop;
			let elementBottomPosition: number = (elementTopPosition + elementHeight)

			console.log("elementTopPosition", elementTopPosition)

			if ((elementBottomPosition >= windowScrollPosition) &&
				(elementTopPosition <= windowBottomPosition)) {

				let delta = Math.abs(elementTopPosition - (windowScrollPosition + windowHeight));
				let deltaSpeed = (delta / 15);
				let deltaSpeedRound = Math.round(deltaSpeed);

				element.style.transform = "translate3d(0, -" + deltaSpeedRound + "px, 0)";
			}
		})
	}

}
